import { Color } from '@api/backend-connector/models';

export enum Colors {
  Red = 'red',
  Blue = 'blue',
  Green = 'green',
  Yellow = 'yellow',
  Grey = 'grey',
  Orange = 'orange',
  Purple = 'purple',
  Pink = 'pink',
  Indigo = 'indigo',
}

export const getColorTranslation = (color: Colors) => {
  switch (color) {
    case 'red':
      return 'i18n.Color.red';
    case 'blue':
      return 'i18n.Color.blue';
    case 'green':
      return 'i18n.Color.green';
    case 'yellow':
      return 'i18n.Color.yellow';
    case 'grey':
      return 'i18n.Color.grey';
    case 'orange':
      return 'i18n.Color.orange';
    case 'purple':
      return 'i18n.Color.purple';
    case 'pink':
      return 'i18n.Color.pink';
    case 'indigo':
      return 'i18n.Color.indigo';
    default:
      return 'i18n.Color.indigo';
  }
};

export const ColorMap: Record<Colors, { bg: string; text: string; code: string }> = {
  [Colors.Red]: { bg: '#fee2e2', text: '#ef4444', code: 'red' },
  [Colors.Blue]: { bg: '#e0f2fe', text: '#0ea5e9', code: 'blue' },
  [Colors.Green]: { bg: '#d1fae5', text: '#10b981', code: 'green' },
  [Colors.Yellow]: { bg: '#fef3c7', text: '#f59e0b', code: 'yellow' },
  [Colors.Grey]: { bg: '#f1f5f9', text: '#64748b', code: 'grey' },
  [Colors.Orange]: { bg: '#ffedd5', text: '#f97316', code: 'orange' },
  [Colors.Purple]: { bg: '#f3e8ff', text: '#a855f7', code: 'purple' },
  [Colors.Pink]: { bg: '#fce7f3', text: '#ec4899', code: 'pink' },
  [Colors.Indigo]: { bg: '#e0e7ff', text: '#6366f1', code: 'indigo' },
};

export const getColor = (color: Color): { bg: string; text: string; code: Colors } => {
  const fromMap = ColorMap[color.code as Colors];
  return {
    code: color.code as Colors,
    bg: fromMap?.bg || color.bg,
    text: fromMap?.text || color.text,
  };
};
